module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/La-Graviere-cc61d72304d76fdec0e31966f1ab2617.jpg";